import React, { ReactElement } from 'react'

type ErrorBoundaryWrapperProps = {
  railsEnv: string;
  children: ReactElement;
}

const ErrorBoundaryWrapper = ({
  railsEnv, children
}: ErrorBoundaryWrapperProps): ReactElement => {
  function errorBoundaryOrFragment (): ReactElement {
    if (railsEnv === 'test') {
      return (
        <>
          {children}
        </>
      )
    }

    return (
      <>
        {children}
      </>
    )
  }

  return (
    errorBoundaryOrFragment()
  )
}

export default ErrorBoundaryWrapper
